import { FaPlane, FaArrowUp, FaArrowDown } from "react-icons/fa";
import { Card } from "../common/Card";
import { ErrorRetry } from "../../common/ErrorRetry";
import { ListShimmer } from "../../common/reportDashBShimmer/ListShimmer";

export function FlightPerformanceSection({
  airlinesState,
  routesState,
  topAirlines,
  topRoutes,
}) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <Card className="p-8 bg-white rounded-2xl shadow-lg shadow-gray-100/50 border border-gray-100 hover:shadow-xl transition-shadow duration-300">
        <div className="mb-6">
          <span className="text-[#1A1A1A] text-base md:text-lg mb-1">
            Top Airlines Performance
          </span>
          <p className="text-sm text-[#6B7280]">
            Leading airline partners by revenue
          </p>
        </div>
        <div className="space-y-3">
          {airlinesState.loading ? (
            <div className="text-center py-10 text-gray-400">
              Loading airlines...
            </div>
          ) : airlinesState.error ? (
            <ErrorRetry
              message={airlinesState.message}
              onRetry={airlinesState.onRetry}
            />
          ) : topAirlines.length > 0 ? (
            topAirlines.map((airline, index) => {
              const isPositive = airline.growthPercentage >= 0;

              return (
                <div
                  key={index}
                  className="group flex items-center justify-between p-5 bg-gradient-to-br from-[#F8F9FC] to-[#F3F4F6] rounded-xl hover:shadow-md hover:scale-[1.01] transition-all duration-200 border border-gray-100"
                >
                  <div className="flex items-center gap-4 flex-1">
                    <div className="relative">
                      <div className="w-12 h-12 rounded-xl bg-white border border-gray-200 flex items-center justify-center shadow-sm group-hover:shadow-md transition-shadow">
                        <FaPlane className="w-6 h-6 text-[#1E61DC]" />
                      </div>

                      <div className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-[#1E61DC] text-white text-xs flex items-center justify-center font-medium">
                        {index + 1}
                      </div>
                    </div>

                    <div>
                      <div className="text-[#1A1A1A] font-medium">
                        {airline.airlineName}
                      </div>

                      <div className="text-sm text-[#6B7280]">
                        {airline.bookings.toLocaleString()} bookings
                      </div>
                    </div>
                  </div>

                  <div className="text-right">
                    <div className="text-[#1A1A1A] font-semibold text-base md:text-lg">
                      ₦{Number(airline.revenue).toLocaleString()}
                    </div>

                    <div
                      className={`flex items-center gap-1 text-sm font-medium ${
                        isPositive ? "text-emerald-600" : "text-red-600"
                      }`}
                    >
                      {isPositive ? (
                        <FaArrowUp className="w-4 h-4" />
                      ) : (
                        <FaArrowDown className="w-4 h-4" />
                      )}

                      <span>
                        {isPositive ? "+" : ""}
                        {airline.growthPercentage}%
                      </span>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="text-center py-10 text-gray-400">
              No airline data available
            </div>
          )}
        </div>
      </Card>

      <Card className="p-8 bg-white rounded-2xl shadow-lg shadow-gray-100/50 border border-gray-100 hover:shadow-xl transition-shadow duration-300">
        <div className="mb-6">
          <span className="text-[#1A1A1A] text-base md:text-lg mb-1">
            Top Routes
          </span>
          <p className="text-sm text-[#6B7280]">
            Most popular flight routes by revenue
          </p>
        </div>

        {routesState.loading ? (
          <ListShimmer rows={5} />
        ) : routesState.error ? (
          <ErrorRetry message={routesState.message} onRetry={routesState.onRetry} />
        ) : topRoutes.length > 0 ? (
          <div className="space-y-3">
            {topRoutes.map((route, index) => (
              <div
                key={route.id || index}
                className="group flex items-center justify-between p-5 bg-gradient-to-br from-[#F8F9FC] to-[#F3F4F6] rounded-xl hover:shadow-md hover:scale-[1.01] transition-all duration-200 border border-gray-100"
              >
                <div className="flex items-center gap-4 flex-1">
                  <div className="relative">
                    <div className="w-12 h-12 rounded-xl bg-white border border-gray-200 flex items-center justify-center shadow-sm group-hover:shadow-md transition-shadow">
                      <FaPlane className="w-6 h-6 text-[#1E61DC]" />
                    </div>

                    <div className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-[#1E61DC] text-white text-xs flex items-center justify-center font-medium">
                      {index + 1}
                    </div>
                  </div>

                  <div>
                    <div className="text-[#1A1A1A] font-medium">
                      {route.route}
                    </div>
                    <div className="text-sm text-[#6B7280]">
                      {route.bookings.toLocaleString()} bookings
                    </div>
                  </div>
                </div>

                <div className="text-right">
                  <div className="text-[#1A1A1A] font-semibold text-base md:text-lg">
                    ₦{route.revenue.toLocaleString()}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-gray-500">No route data available</div>
        )}
      </Card>
    </div>
  );
}
